import type {CoreExportFormat, RawComponentExport} from '@wix/document-services-types'
import {getVersion} from './utils/version'
import type {CoreConverterAPI} from './types'
import {packComponent, unpackComponent} from './pluginsRunner'

export * from './constants'
export * from './types'

const converter: CoreConverterAPI['converter'] = {
    pack: (rawComponentExport: RawComponentExport): CoreExportFormat => {
        return packComponent(rawComponentExport)
    },
    unpack: (componentExport: CoreExportFormat): RawComponentExport => {
        return unpackComponent(componentExport)
    },
    getVersion
}

export {converter}
